<template>
<div class="flex items-center justify-center w-full h-[144px] bg-white max-w-[350px] md:max-w-full">
    <slot />
</div>

</template>

<script setup>
</script>

<style>
</style>
